import React from 'react';
import { Button, ButtonVariant } from '@components/Button';
import { Popup } from '@progress/kendo-react-popup';
import ClickAwayListener from 'react-click-away-listener';
import { translate } from '@utils/i18n';
import { IndexNamespace } from '../constants';
export default function NoteActions({ canEdit, canDelete, onEdit, onDelete }) {
    const anchor = React.useRef(null);
    const [open, setOpen] = React.useState(false);
    if (!canEdit && !canDelete) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { className: "noteEllipsisButton", variant: ButtonVariant.IconButton, onClick: () => setOpen(true), ref: anchor },
            React.createElement("i", { className: "fa-light fa-ellipsis" })),
        React.createElement(Popup, { anchor: anchor.current, show: open, onClose: () => setOpen(false) },
            React.createElement(ClickAwayListener, { onClickAway: () => setOpen(false) },
                React.createElement("div", { id: "popup_convert", className: "qmb-popup--action-list" },
                    React.createElement("ul", { role: "presentation" },
                        canEdit && (React.createElement("li", { role: "presentation" },
                            React.createElement("button", { type: "button", onClick: () => {
                                    onEdit();
                                    setOpen(false);
                                } },
                                React.createElement("i", { className: "fa-light fa-pencil" }),
                                translate('edit_note', { namespace: IndexNamespace })))),
                        canDelete && (React.createElement("li", { role: "presentation" },
                            React.createElement("button", { type: "button", onClick: () => {
                                    onDelete();
                                    setOpen(false);
                                } },
                                React.createElement("i", { className: "fa-light fa-trash-can" }),
                                translate('delete', { namespace: 'features.commons' }))))))))));
}
